function initDesktopMegaMenus(scope = document) {
  scope.querySelectorAll("header-menu > details").forEach((details) => {
    if (details.dataset.hoverMenuBound === "true") {
      return;
    }

    details.dataset.hoverMenuBound = "true";
    let closeTimer;

    details.addEventListener("mouseenter", () => {
      if (!window.matchMedia("(min-width: 990px)").matches) {
        return;
      }

      window.clearTimeout(closeTimer);
      document
        .querySelectorAll("header-menu > details[open]")
        .forEach((openDetails) => {
          if (openDetails !== details) {
            openDetails.removeAttribute("open");
          }
        });
      details.setAttribute("open", "");
    });

    details.addEventListener("mouseleave", () => {
      if (!window.matchMedia("(min-width: 990px)").matches) {
        return;
      }

      closeTimer = window.setTimeout(() => {
        details.removeAttribute("open");
      }, 140);
    });
  });
}

initDesktopMegaMenus();

document.addEventListener("shopify:section:load", (event) => {
  initDesktopMegaMenus(event.target);
});
//  // Function to select a random option
// function selectRandomOption() {
//     const selectElement = document.getElementById("SortBy");
//     const randomIndex = Math.floor(Math.random() * selectElement.options.length);

//     // Set the selected attribute on the randomly chosen option
//     selectElement.options[randomIndex].selected = true;

//     // Update the URL with the selected value
//     const selectedValue = selectElement.options[randomIndex].value;
//     updateURL(selectedValue);
// }

// // Function to update the URL
// function updateURL(selectedValue) {
//     const currentURL = new URL(window.location.href);
//     currentURL.searchParams.set('sort_by', selectedValue);
//     window.history.pushState({}, '', currentURL.toString());
// }

// Call the function on DOMContentLoaded event
// document.addEventListener("DOMContentLoaded", function () {
//     selectRandomOption();

//     // Add click event listener to manually selected options
//     const selectElement = document.getElementById("SortBy");
//     selectElement.addEventListener("change", function () {
//         const clickedOption = this.options[this.selectedIndex];

//         // Remove the "selected" attribute from all options
//         for (let i = 0; i < this.options.length; i++) {
//             this.options[i].removeAttribute("selected");
//         }

//         // Add the "selected" attribute to the clicked option
//         clickedOption.setAttribute("selected", "selected");

//         // Update the URL with the clicked value
//         const clickedValue = clickedOption.value;
//         updateURL(clickedValue);
//     });
// });

// globoo custom swatch

// $(document).ready(function() {
// $("body").on("click", ".ColorSwatch__Radio",  function() {
//         var main_data_image = $(this).attr("data-image-url");
// console.log(main_data_image);
// $(this).parents(".grid__item").find(".ProductItem__Image").attr("srcset", main_data_image);

//     });

// $('.grid__item').each(function() {
//     var $container = $(this);

//     $container.find('.custom_variant .ColorSwatch__Radio, .custom_variant .SizeSwatch__Radio').on('change', function() {
//         var option1 = $container.find('input[data-type="Size"]:checked').val();
//         var option2 = $container.find('input[data-type="Color"]:checked').val();
//        // console.log("option1", option1, "option2", option2)

//         // Check if either option1 or option2 is available
//         if (option1 || option2) {
//             var finalOption;
//             if (option1 && option2) {
//                 finalOption = option1 + " / " + option2;
//             } else {
//                 finalOption = option1 || option2;
//             }

//            // console.log("Final Option:", finalOption);

//             var $selectedOption = $container.find('.varts_list option').filter(function() {
//                 return $(this).text() === finalOption;
//             });

//             if ($selectedOption.length > 0) {
//                 var variantId = $selectedOption.attr('pro_id');
//                // console.log("variantId:", variantId);

//                 // Update the hidden input field value
//                 $container.find('.custom_add_cart').val(variantId);
//                // console.log("Updated custom_add_cart value:", $container.find('.custom_add_cart').val());
//             } else {
// //console.log("No matching option found for", finalOption);
//             }
//         } else {
//            // console.log("Both options are not available.");
//         }
//     });
// });

// $('.cst_mmm option').removeAttr('selected')
//     $('.cst_mmm option').filter(function() {
//      return $(this).text() === finalop;
//     }).attr('selected', true);

//     $(document).on("click", ".cart_submitbtn", function() {

//  var Variant_id = $(this).closest(".custom_add_cart").val();
//  console.log("djdhddhx", Variant_id);

//  var items = [
//         {
//             quantity: 1,
//             id: Variant_id
//         }
//     ];
//         $.ajax({
//            method: "POST",
//         dataType: "json",
//         contentType: "application/json",  // Add this line to set the content type
//         url: "/cart/add.js",
//         data: JSON.stringify({ items: items }),  // Convert items array to JSON string
//         success: function(response) {
//           console.log(response);
// $("cart-drawer").addClass("active");
//  $("cart-drawer").load(location.href + " #CartDrawer");
//  $("#cart-icon-bubble").load(location.href + " #cart-icon-bubble");

//             }
//         });
//     });
// });

// window.addEventListener('load', function () {
//     setTimeout(function () {
//         var addToCartButtons = document.querySelectorAll(".btn.btn-globo.globo--add-to-cart.globo-ajax-form-cart");

//         for (var i = 0; i < addToCartButtons.length; i++) {
//             var addToCartButton = addToCartButtons[i];

//             // Add a click event listener to the button
//             addToCartButton.addEventListener("click", function () {
//               setTimeout(function () {
//                 window.location.href = "/cart"; // Change to your actual cart page URL
//                 }, 1500);
//             });
//         }
//     }, 2000);
// });

$(document).ready(function () {
  $(document).on("change", ".custom__select-select-1", function () {
    // Remove the 'selected' attribute from all options
    $(this).find("option").removeAttr("selected");
    var selectedValue = $(this).val();

    $(this)
      .find('option[value="' + selectedValue + '"]')
      .attr("selected", "selected");

    // Perform other actions based on the selected value
    //console.log('Selected Value:', selectedValue);
    $(".add_free-product-1").attr("data-varid", selectedValue);
  });

  $(document).on("change", ".custom__select-select-2", function () {
    // Remove the 'selected' attribute from all options
    $(this).find("option").removeAttr("selected");
    var selectedValue2 = $(this).val();

    $(this)
      .find('option[value="' + selectedValue2 + '"]')
      .attr("selected", "selected");

    // Perform other actions based on the selected value
    //console.log('Selected Value:', selectedValue2);
    $(".add_free-product-2").attr("data-varid", selectedValue2);
  });

  $("body").on("click", ".custom__addtocart", function () {
    var get_val = $(this).attr("data-varid");
    $.ajax({
      method: "POST",
      dataType: "json",
      url: "/cart/add.json",
      contentType: "application/json",
      data: JSON.stringify({
        id: get_val,
        quantity: 1,
      }),
      success: function (response) {
        $(".custom__addtocart").attr("disabled", true);
        $(".custom__select-select-1").attr("disable", true);
        $(".custom__select-select-2").attr("disable", true);
        $("cart-drawer").load(location.href + " #CartDrawer");
        $("#cart-icon-bubble").load(location.href + " #cart-icon-bubble");
      },
    });
  });

  $("body").on(
    "click",
    '.quantity__button[name="minus"], .custom_remove',
    function () {
      setTimeout(function () {
        // Make an AJAX request to get the cart information
        $.ajax({
          method: "GET",
          dataType: "json",
          url: "/cart.js",
          success: function (cartResponse) {
            //console.log("chdusicgfeue", cartResponse);
            // Check if the cart is empty
            $("cart-drawer").load(location.href + " #CartDrawer");

            // Extract the cart total from the response
            var cartTotal = parseFloat(cartResponse.total_price);
            var cartItems = cartResponse.items;

            //  console.log('Cart Total:', cartTotal);

            // Check if the cart total is less than 30000
            if (cartTotal < 30000) {
              // Loop through the cart items
              for (var i = 0; i < cartItems.length; i++) {
                var item = cartItems[i];
                var itemTitle = item.title;
                var itemPrice = parseFloat(item.final_price);

                // console.log('Item:', itemTitle);
                // console.log('Item Price:', itemPrice);

                // Check if the item price is 0 and remove the item
                if (itemPrice === 0) {
                  var itemId = item.id;
                  console.log("Item ID:", itemId);
                  // Make an AJAX request to remove the item from the cart
                  $.ajax({
                    method: "POST",
                    url: "/cart/change.js",
                    dataType: "json",
                    data: {
                      id: item.variant_id,
                      quantity: 0,
                    },
                    success: function (removeResponse) {
                      $("cart-drawer").load(location.href + " #CartDrawer");
                      $("#cart-icon-bubble").load(
                        location.href + " #cart-icon-bubble"
                      );
                      $(".custom-free_gift").css("display", "none");
                      //console.log('Item removed successfully:', removeResponse);
                      if (removeResponse.item_count === 0) {
                        // Display your empty cart message
                        $("cart-drawer").addClass("is-empty");
                        $("cart-drawer").load(location.href + " #CartDrawer");
                        // $("cart-drawer").removeClass("active");
                        $(".custom-free_gift").css("display", "none");
                        //console.log('Cart is empty. Displaying empty message.');

                        // You can update your HTML to show an empty cart message here
                      }
                    },
                    error: function (removeError) {
                      //  console.error('Error removing item:', removeError);
                    },
                  });
                }
              }
            }
          },
          error: function (error) {
            //  console.error('Error getting cart information:', error);
          },
        });
      }, 1000);
    }
  );
});

function updateCollectionCardSecondaryMedia($container, $selectedColorInput) {
  var mediaType = ($selectedColorInput.attr("data-hover-media-type") || "none").toLowerCase();
  var hoverImageUrl = $selectedColorInput.attr("data-hover-image-url");
  var hoverVideoUrl = $selectedColorInput.attr("data-hover-video-url");
  var hoverVideoPoster = $selectedColorInput.attr("data-hover-video-poster");
  var $mediaEffect = $container.find(".card__media .media.media--hover-effect").first();

  if (!$mediaEffect.length) {
    return;
  }

  $mediaEffect.children().slice(1).each(function () {
    if (this.tagName === "VIDEO") {
      try {
        this.pause();
        this.currentTime = 0;
      } catch (error) {}
    }
    this.remove();
  });

  if (mediaType === "image" && hoverImageUrl) {
    var image = document.createElement("img");
    image.className = "motion-reduce ProductItem__Image product-card-secondary-media";
    image.loading = "lazy";
    image.src = hoverImageUrl;
    image.setAttribute("src", hoverImageUrl);
    image.alt = "";
    $mediaEffect.append(image);
    return;
  }

  if (mediaType === "video" && hoverVideoUrl) {
    var video = document.createElement("video");
    video.className = "motion-reduce product-card-secondary-media";
    video.muted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;
    if (hoverVideoPoster) {
      video.poster = hoverVideoPoster;
    }

    var source = document.createElement("source");
    source.src = hoverVideoUrl;
    source.type = "video/mp4";
    video.appendChild(source);
    $mediaEffect.append(video);
    video.load();

    if ($container.is(":hover")) {
      window.requestAnimationFrame(function () {
        video.play().catch(function () {});
      });
    }
  }
}

function preloadCollectionCardMedia($container) {
  if (!$container || !$container.length || $container.data("swatch-media-preloaded")) {
    return;
  }

  $container.data("swatch-media-preloaded", true);

  $container.find('.ColorSwatch__Radio').each(function () {
    var imageUrl = $(this).attr("data-image-url");
    var hoverImageUrl = $(this).attr("data-hover-image-url");
    var hoverVideoUrl = $(this).attr("data-hover-video-url");

    if (imageUrl) {
      var mainImage = new window.Image();
      mainImage.src = imageUrl;
    }

    if (hoverImageUrl) {
      var hoverImage = new window.Image();
      hoverImage.src = hoverImageUrl;
    }

    if (hoverVideoUrl) {
      var preloadVideo = document.createElement("video");
      preloadVideo.preload = "metadata";
      preloadVideo.src = hoverVideoUrl;
    }
  });
}

function syncCollectionCardSwatchState($container) {
  if (!$container || !$container.length) {
    return;
  }

  var option1 = $container.find('input[data-type="Size"]:checked').val();
  var option2 = $container.find('input[data-type="Color"]:checked').val();
  var $selectedColorInput = $container.find('input[data-type="Color"]:checked');
  var selectedColorImage = $selectedColorInput.attr("data-image-url");

  if (selectedColorImage) {
    var primaryImage = $container.find(".ProductItem__Image").first().get(0);

    if (primaryImage) {
      primaryImage.removeAttribute("srcset");
      primaryImage.removeAttribute("sizes");
      primaryImage.src = selectedColorImage;
      primaryImage.setAttribute("src", selectedColorImage);
    }

  }

  if ($selectedColorInput.length) {
    updateCollectionCardSecondaryMedia($container, $selectedColorInput);
  }

  if (option1 || option2) {
    var finalOption;
    if (option1 && option2) {
      finalOption = option1 + " / " + option2;
    } else {
      finalOption = option1 || option2;
    }

    var $selectedOption = $container
      .find(".varts_list option")
      .filter(function () {
        return $(this).text().includes(finalOption);
      });

    if ($selectedOption.length > 0) {
      var variantId = $selectedOption.attr("pro_id");
      $container.find(".custom_add_cart").val(variantId);
    }
  }

  var variantController = $container.find("custom-variant-el").get(0);
  if (variantController && typeof variantController.onVariantChange === "function") {
    variantController.onVariantChange();
  }
}

$(document).on(
  "change",
  ".product-card-wrapper .ColorSwatch__Radio, .product-card-wrapper .SizeSwatch__Radio",
  function () {
    syncCollectionCardSwatchState($(this).closest(".product-card-wrapper"));
  }
);

$(document).on(
  "click",
  ".product-card-wrapper .ColorSwatch__Radio, .product-card-wrapper .SizeSwatch__Radio",
  function () {
    var $input = $(this);
    window.setTimeout(function () {
      syncCollectionCardSwatchState($input.closest(".product-card-wrapper"));
    }, 0);
  }
);

$(document).on("mouseenter", ".product-card-wrapper", function () {
  preloadCollectionCardMedia($(this));
});

$(document).on("mouseenter", ".product-card-wrapper--video-secondary", function () {
  preloadCollectionCardMedia($(this));
  var video = $(this).find(".card__media .media.media--hover-effect > video").get(0);
  if (video) {
    try {
      video.play().catch(function () {});
    } catch (error) {}
  }
});

function getVariantDataForPicker(variantPicker) {
  const variantDataNode = variantPicker.querySelector(
    'script[type="application/json"]'
  );
  if (!variantDataNode) {
    return [];
  }

  try {
    return JSON.parse(variantDataNode.textContent);
  } catch (error) {
    return [];
  }
}

function getCurrentVariantForPicker(variantPicker) {
  const sectionId = variantPicker.dataset.section;
  if (!sectionId) {
    return null;
  }

  const variantId = document.querySelector(
    `#product-form-${sectionId} input[name="id"]`
  )?.value;

  if (variantId) {
    return (
      getVariantDataForPicker(variantPicker).find(
        (variant) => String(variant.id) === String(variantId)
      ) || null
    );
  }

  const selectedOptions =
    variantPicker.tagName === "VARIANT-RADIOS"
      ? [...variantPicker.querySelectorAll("fieldset")].map(
          (fieldset) => fieldset.querySelector("input:checked")?.value
        )
      : [...variantPicker.querySelectorAll("select")].map(
          (select) => select.value
        );

  return (
    getVariantDataForPicker(variantPicker).find((variant) =>
      variant.options.every(
        (optionValue, index) => selectedOptions[index] === optionValue
      )
    ) || null
  );
}

function syncLegacyProductPageImageLayer(variantPicker) {
  const section = variantPicker.closest('section[id^="MainProduct-"]');
  if (!section) {
    return;
  }

  section.querySelectorAll(".first_image.desk_version").forEach((image) => {
    image.style.display = "none";
  });

  section.querySelectorAll(".onclick_variant.desk_version").forEach((image) => {
    image.style.display = "block";
  });
}

const productPageGalleryOriginalOrder = new WeakMap();

function normalizeProductOptionValue(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, "-");
}

function getProductPageColorFieldset(variantPicker) {
  if (!variantPicker || variantPicker.tagName !== "VARIANT-RADIOS") {
    return null;
  }

  return (
    [...variantPicker.querySelectorAll("fieldset")].find((fieldset) => {
      const classes = fieldset.className || "";
      const labelText = fieldset.querySelector("legend, .form__label")?.textContent || "";
      return /color/i.test(classes) || /color/i.test(labelText);
    }) || null
  );
}

function getProductPageColorIndex(variantPicker, colorInputs) {
  if (!variantPicker) {
    return 0;
  }

  const variantData = getVariantDataForPicker(variantPicker);
  const colorFieldset = getProductPageColorFieldset(variantPicker);
  const fieldsets =
    variantPicker.tagName === "VARIANT-RADIOS"
      ? [...variantPicker.querySelectorAll("fieldset")]
      : [];

  if (colorFieldset && fieldsets.length) {
    const index = fieldsets.indexOf(colorFieldset);
    if (index > -1) {
      return index;
    }
  }

  const firstVariant = variantData[0];
  const selectedColor = colorInputs.find((input) => input.checked)?.value;

  if (firstVariant?.options?.length && selectedColor) {
    const normalizedSelectedColor = normalizeProductOptionValue(selectedColor);
    const matchedIndex = firstVariant.options.findIndex(
      (optionValue) =>
        normalizeProductOptionValue(optionValue) === normalizedSelectedColor
    );

    if (matchedIndex > -1) {
      return matchedIndex;
    }
  }

  return 0;
}

function captureOriginalProductPageGalleryOrder(section) {
  if (!section) {
    return null;
  }

  const existingState = productPageGalleryOriginalOrder.get(section);
  if (existingState) {
    return existingState;
  }

  const viewerList = section.querySelector('[id^="Slider-Gallery-"]');
  const thumbnailList = section.querySelector('[id^="Slider-Thumbnails-"]');

  if (!viewerList || !thumbnailList) {
    return null;
  }

  const state = {
    viewerList,
    thumbnailList,
    viewerItems: [...viewerList.querySelectorAll(":scope > li[data-media-id]")],
    thumbnailItems: [
      ...thumbnailList.querySelectorAll('li[data-target]:not(.slick-cloned)'),
    ],
  };

  if (
    state.thumbnailItems.length &&
    state.thumbnailItems.length !== state.viewerItems.length
  ) {
    const seenTargets = new Set();
    state.thumbnailItems = state.thumbnailItems.filter((item) => {
      if (seenTargets.has(item.dataset.target)) {
        return false;
      }
      seenTargets.add(item.dataset.target);
      return true;
    });
  }

  state.thumbnailParent =
    state.thumbnailItems[0]?.parentElement || state.thumbnailList;
  state.viewerParent = state.viewerItems[0]?.parentElement || state.viewerList;

  productPageGalleryOriginalOrder.set(section, state);
  return state;
}

function reorderProductPageMediaGroupToTop(variantPicker) {
  const section = variantPicker.closest('section[id^="MainProduct-"]');
  const originalOrderState = captureOriginalProductPageGalleryOrder(section);
  const colorFieldset = getProductPageColorFieldset(variantPicker);
  const colorInputs = [...(colorFieldset?.querySelectorAll('input[type="radio"]') || [])];

  if (!section || !originalOrderState || colorInputs.length < 2) {
    return;
  }

  const selectedColor = colorInputs.find((input) => input.checked)?.value;
  if (!selectedColor) {
    return;
  }

  const colorOrder = colorInputs.map((input) => input.value);
  const colorIndex = getProductPageColorIndex(variantPicker, colorInputs);
  const variantData = getVariantDataForPicker(variantPicker);
  const sectionId = variantPicker.dataset.section;

  if (!variantData.length || !sectionId) {
    return;
  }

  const colorStartEntries = colorOrder
    .map((color, index) => {
      if (index === 0) {
        return { color, startIndex: 0 };
      }

      const matchingVariant = variantData.find((variant) => {
        const variantColor = variant.options?.[colorIndex];
        return (
          normalizeProductOptionValue(variantColor) ===
            normalizeProductOptionValue(color) && variant.featured_media?.id
        );
      });

      if (!matchingVariant?.featured_media?.id) {
        return null;
      }

      const mediaIndex = originalOrderState.viewerItems.findIndex(
        (item) =>
          item.dataset.mediaId === `${sectionId}-${matchingVariant.featured_media.id}`
      );

      if (mediaIndex < 0) {
        return null;
      }

      return {
        color,
        startIndex: mediaIndex,
      };
    })
    .filter(Boolean)
    .sort((left, right) => left.startIndex - right.startIndex);

  if (!colorStartEntries.length) {
    return;
  }

  const mediaBlocks = colorStartEntries.map((entry, index) => {
    const nextStartIndex =
      colorStartEntries[index + 1]?.startIndex ?? originalOrderState.viewerItems.length;

    return {
      color: entry.color,
      viewerItems: originalOrderState.viewerItems.slice(entry.startIndex, nextStartIndex),
      thumbnailItems: originalOrderState.thumbnailItems.slice(
        entry.startIndex,
        nextStartIndex
      ),
      thumbnailTargets: originalOrderState.thumbnailItems
        .slice(entry.startIndex, nextStartIndex)
        .map((item) => item.dataset.target),
    };
  });

  const normalizedSelectedColor = normalizeProductOptionValue(selectedColor);
  const selectedBlock = mediaBlocks.find(
    (block) => normalizeProductOptionValue(block.color) === normalizedSelectedColor
  );

  if (!selectedBlock) {
    return;
  }

  const orderedBlocks = [
    selectedBlock,
    ...mediaBlocks.filter((block) => block !== selectedBlock),
  ];

  originalOrderState.viewerParent =
    originalOrderState.viewerItems[0]?.parentElement || originalOrderState.viewerList;
  originalOrderState.thumbnailParent =
    originalOrderState.thumbnailItems[0]?.parentElement || originalOrderState.thumbnailList;

  originalOrderState.viewerParent.append(
    ...orderedBlocks.flatMap((block) => block.viewerItems)
  );

  if (!window.jQuery) {
    originalOrderState.thumbnailParent.append(
      ...orderedBlocks.flatMap((block) => block.thumbnailItems)
    );
    return;
  }

  const $thumbnailSlider = window.jQuery(originalOrderState.thumbnailList);
  let originalSettings = null;

  if ($thumbnailSlider.hasClass("slick-initialized")) {
    try {
      const slickInstance = $thumbnailSlider.slick("getSlick");
      originalSettings = slickInstance?.originalSettings || null;
    } catch (error) {}

    $thumbnailSlider.slick("unslick");
  }

  const reorderedThumbnailItems = [...originalOrderState.thumbnailList.querySelectorAll('li[data-target]:not(.slick-cloned)')];
  const thumbnailItemsByTarget = new Map();
  reorderedThumbnailItems.forEach((item) => {
    if (!thumbnailItemsByTarget.has(item.dataset.target)) {
      thumbnailItemsByTarget.set(item.dataset.target, item);
    }
  });

  originalOrderState.thumbnailParent =
    reorderedThumbnailItems[0]?.parentElement || originalOrderState.thumbnailList;

  originalOrderState.thumbnailParent.append(
    ...orderedBlocks.flatMap((block) =>
      block.thumbnailTargets
        .map((target) => thumbnailItemsByTarget.get(target))
        .filter(Boolean)
    )
  );

  if (!window.jQuery) {
    return;
  }

  const slickSettings = originalSettings || {
    dots: false,
    vertical: true,
    slidesToShow: 3,
    infinite: false,
    swipe: false,
    arrows: true,
  };

  $thumbnailSlider.slick(slickSettings);
}

function showAllProductPageThumbnails(variantPicker) {
  const section = variantPicker.closest('section[id^="MainProduct-"]');
  if (!section) {
    return;
  }

  section.querySelectorAll("[thumbnail-color]").forEach((thumbnail) => {
    thumbnail.style.display = "";
    thumbnail.hidden = false;
  });

  if (!window.jQuery) {
    return;
  }

  const $thumbnailSlides = window.jQuery(section).find(".slides.slick-initialized");
  $thumbnailSlides.each(function () {
    window.jQuery(this).slick("setPosition");
  });
}

function ensureActiveProductThumbnailVisible(section) {
  if (!section) {
    return;
  }

  const activeThumb = section.querySelector(
    '.thumbnail-list__item button[aria-current="true"]'
  )?.closest(".thumbnail-list__item");
  const slickElement = section.querySelector(".product-thumb.slick-initialized");

  if (!activeThumb) {
    return;
  }

  if (window.jQuery && slickElement) {
    const $slick = window.jQuery(slickElement);
    try {
      const slick = $slick.slick("getSlick");
      const activeIndex = Number(activeThumb.getAttribute("data-slick-index"));
      const slidesToShow = Number(slick.options.slidesToShow) || 1;
      const maxStartIndex = Math.max(0, slick.slideCount - slidesToShow);
      const targetIndex = Math.max(0, Math.min(activeIndex, maxStartIndex));

      if (!Number.isNaN(activeIndex)) {
        $slick.slick("slickGoTo", targetIndex, false);
        window.setTimeout(() => {
          $slick.slick("setPosition");
          if (targetIndex === 0) {
            slick.currentSlide = 0;
            slick.animating = false;
            slick.swipeLeft = null;
            if (typeof slick.setCSS === "function") {
              slick.setCSS(0);
            }
            const track = section.querySelector(".product-thumb .slick-track");
            if (track) {
              track.style.transform = "translate3d(0px, 0px, 0px)";
            }
            window.setTimeout(() => {
              slick.currentSlide = 0;
              if (typeof slick.setCSS === "function") {
                slick.setCSS(0);
              }
              $slick.slick("setPosition");
            }, 120);
          }
        }, 80);
        return;
      }
    } catch (error) {}
  }

  activeThumb.scrollIntoView({ block: "nearest", behavior: "smooth" });
}

function overrideProductPageThumbnailFiltering() {
  if (typeof VariantSelects === "undefined") {
    return;
  }

  if (VariantSelects.prototype._lucieeThumbnailFilterOverrideApplied) {
    return;
  }

  VariantSelects.prototype._lucieeThumbnailFilterOverrideApplied = true;

  VariantSelects.prototype.filterMedia = function () {
    showAllProductPageThumbnails(this);
  };

  VariantSelects.prototype.updateMedia = function () {
    if (!this.currentVariant || !this.currentVariant.featured_media) {
      return;
    }

    const syncSelectedMedia = () => {
      const mediaGalleries = document.querySelectorAll(
        `[id^="MediaGallery-${this.dataset.section}"]`
      );

      mediaGalleries.forEach((gallery) => {
        if (typeof gallery.setActiveMedia === "function") {
          gallery.setActiveMedia(
            `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
            false
          );
        }
      });

      const modalContent = document.querySelector(
        `#ProductModal-${this.dataset.section} .product-media-modal__content`
      );
      if (!modalContent) {
        return;
      }

      const modalMedia = modalContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
      if (modalMedia) {
        modalContent.prepend(modalMedia);
      }
    };

    syncSelectedMedia();
    window.requestAnimationFrame(syncSelectedMedia);
    window.setTimeout(syncSelectedMedia, 120);
  };
}

function syncProductPageMediaState(variantPicker) {
  showAllProductPageThumbnails(variantPicker);
}

function syncProductPageSelectedMedia(variantPicker) {
  const sectionId = variantPicker.dataset.section;
  const currentVariant = getCurrentVariantForPicker(variantPicker);
  const featuredMediaId = currentVariant?.featured_media?.id;
  let useFirstGalleryMedia = false;

  syncLegacyProductPageImageLayer(variantPicker);
  reorderProductPageMediaGroupToTop(variantPicker);

  if (!sectionId || !featuredMediaId) {
    return;
  }

  const colorFieldset = getProductPageColorFieldset(variantPicker);

  if (colorFieldset) {
    const colorInputs = [...colorFieldset.querySelectorAll('input[type="radio"]')];
    const checkedColor = colorInputs.find((input) => input.checked)?.value;
    const firstColor = colorInputs[0]?.value;

    if (checkedColor && firstColor && checkedColor === firstColor) {
      useFirstGalleryMedia = true;
    }
  }

  document
    .querySelectorAll(`[id^="MediaGallery-${sectionId}"]`)
    .forEach((mediaGallery) => {
      let galleryTarget = `${sectionId}-${featuredMediaId}`;

      if (useFirstGalleryMedia) {
        const firstMediaItem = mediaGallery.querySelector("[data-media-id]");
        if (firstMediaItem?.dataset.mediaId) {
          galleryTarget = firstMediaItem.dataset.mediaId;
        }
      }

      if (typeof mediaGallery.setActiveMedia === "function") {
        mediaGallery.setActiveMedia(galleryTarget, false);
      }
    });

  const section = variantPicker.closest('section[id^="MainProduct-"]');
  if (section) {
    window.setTimeout(() => ensureActiveProductThumbnailVisible(section), 60);
    window.setTimeout(() => ensureActiveProductThumbnailVisible(section), 260);
  }
}

function syncProductPageVariantFromUrl() {
  const variantId = new URLSearchParams(window.location.search).get("variant");
  if (!variantId) {
    return;
  }

  document
    .querySelectorAll("variant-radios, variant-selects")
    .forEach((variantPicker) => {
      const matchingVariant = getVariantDataForPicker(variantPicker).find(
        (variant) => String(variant.id) === String(variantId)
      );
      if (!matchingVariant) {
        return;
      }

      let changedInput = null;

      if (variantPicker.tagName === "VARIANT-RADIOS") {
        const fieldsets = [...variantPicker.querySelectorAll("fieldset")];
        matchingVariant.options.forEach((optionValue, index) => {
          const input = [...(fieldsets[index]?.querySelectorAll("input") || [])].find(
            (radio) => radio.value === optionValue
          );
          if (input) {
            input.checked = true;
            changedInput = input;
          }
        });
      } else {
        const selects = [...variantPicker.querySelectorAll("select")];
        matchingVariant.options.forEach((optionValue, index) => {
          const select = selects[index];
          if (select) {
            select.value = optionValue;
            changedInput = select;
          }
        });
      }

      if (changedInput) {
        changedInput.dispatchEvent(new Event("change", { bubbles: true }));
        window.requestAnimationFrame(() => {
          syncProductPageMediaState(variantPicker);
          window.setTimeout(() => {
            syncProductPageSelectedMedia(variantPicker);
          }, 120);
        });
      }
  });
}

function initProductDetailAccordions() {
  document.querySelectorAll(".product__detail-accordion").forEach((details) => {
    const summary = details.querySelector("summary");
    const content = details.querySelector(".product__detail-content");

    if (
      !summary ||
      !content ||
      details.dataset.accordionAnimationBound === "true"
    ) {
      return;
    }

    details.dataset.accordionAnimationBound = "true";

    let animation = null;
    let isClosing = false;
    let isExpanding = false;

    const finishAnimation = (open) => {
      details.open = open;
      animation = null;
      isClosing = false;
      isExpanding = false;
      details.style.height = "";
      details.style.overflow = "";
    };

    const closeAccordion = () => {
      isClosing = true;
      details.style.overflow = "hidden";

      if (animation) {
        animation.cancel();
      }

      animation = details.animate(
        [
          { height: `${details.offsetHeight}px` },
          { height: `${summary.offsetHeight}px` },
        ],
        { duration: 220, easing: "ease" }
      );

      animation.onfinish = () => finishAnimation(false);
      animation.oncancel = () => {
        isClosing = false;
      };
    };

    const openAccordion = () => {
      isExpanding = true;
      details.style.height = `${details.offsetHeight}px`;
      details.open = true;
      details.style.overflow = "hidden";

      window.requestAnimationFrame(() => {
        if (animation) {
          animation.cancel();
        }

        animation = details.animate(
          [
            { height: `${details.offsetHeight}px` },
            { height: `${summary.offsetHeight + content.offsetHeight}px` },
          ],
          { duration: 220, easing: "ease" }
        );

        animation.onfinish = () => finishAnimation(true);
        animation.oncancel = () => {
          isExpanding = false;
        };
      });
    };

    summary.addEventListener("click", (event) => {
      event.preventDefault();

      if (isClosing || !details.open) {
        openAccordion();
      } else if (isExpanding || details.open) {
        closeAccordion();
      }
    });
  });
}

function updateProductPageVariantUrl(variantPicker) {
  const sectionId = variantPicker.dataset.section;
  const productUrl = variantPicker.dataset.url;
  if (!sectionId || !productUrl) {
    return;
  }

  window.requestAnimationFrame(() => {
    const variantInput = document.querySelector(
      `#product-form-${sectionId} input[name="id"]`
    );
    if (!variantInput?.value) {
      return;
    }

    const nextUrl = `${productUrl}?variant=${variantInput.value}`;
    window.history.replaceState({}, "", nextUrl);
  });
}

overrideProductPageThumbnailFiltering();

document.addEventListener("DOMContentLoaded", syncProductPageVariantFromUrl);
document.addEventListener("DOMContentLoaded", initProductDetailAccordions);

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll("variant-radios, variant-selects")
    .forEach((variantPicker) => {
      window.setTimeout(() => {
        syncProductPageMediaState(variantPicker);
      }, 120);
    });
});

document.addEventListener("change", (event) => {
  const variantPicker = event.target.closest("variant-radios, variant-selects");
  if (!variantPicker) {
    return;
  }

  updateProductPageVariantUrl(variantPicker);
  window.requestAnimationFrame(() => {
    syncProductPageMediaState(variantPicker);
    syncLegacyProductPageImageLayer(variantPicker);
    window.setTimeout(() => {
      syncProductPageSelectedMedia(variantPicker);
    }, 120);
  });
});

class CustomVariantEl extends HTMLElement {
  connectedCallback() {
    if (this.initialized) {
      return;
    }

    this.getVariantData();
    this.texts = {
      noSelectedOptionBtnText: this.getAttribute("no-selected-option-btn-txt"),
      soldOutBtnText: this.getAttribute("sold-out-btn-txt"),
      addToCartBtnText: this.getAttribute("add-to-cart-btn-txt"),
    };

    this.initialized = true;
    const optionScope = this.closest(".product-card-wrapper") || this;
    this.optionIdexes = {
      color:
        optionScope.querySelector('input[data-type="Color"]')?.getAttribute(
          "data-index"
        ) - 1,
      size:
        optionScope.querySelector('input[data-type="Size"]')?.getAttribute(
          "data-index"
        ) - 1,
    };

    this.onVariantChange = this.onVariantChange.bind(this);
    this.addEventListener("change", this.onVariantChange);
    this.updateOptionsAvailability();
    this.syncCollectionCardSizeLinks();
    this.updateAddToCartButton();
  }

  onVariantChange() {
    this.updateOptionsAvailability();
    this.syncCollectionCardSizeLinks();
    this.updateAddToCartButton();
  }

  updateOptionsAvailability() {
    if (
      this.variantData.length <= 1 ||
      !this._hasColorSelector() ||
      !this._hasSizeSelector()
    ) {
      return;
    }

    const optionScope = this.closest(".product-card-wrapper") || this;
    const selectedColor = optionScope.querySelector('input[data-type="Color"]:checked')
      ?.value;
    if (!selectedColor) {
      return;
    }

    const sizeInputs = [...optionScope.querySelectorAll('input.SizeSwatch__Radio')];
    const availableOptionInputsValue = this.variantData
      .filter((variant) => variant.available)
      .filter(
        (variant) =>
          variant.options[this.optionIdexes.color] === selectedColor
      )
      .map((variant) => variant.options[this.optionIdexes.size]);
    this.setInputAvailability(sizeInputs, availableOptionInputsValue);
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.disabled = false;
      } else {
        input.disabled = true;
        input.checked = false;
      }
    });
  }

  updateAddToCartButton() {
    const btn = this.querySelector(".cart_submitbtn");
    if (!btn) {
      return;
    }

    const hasColorSelector = this._hasColorSelector();
    const hasSizeSelector = this._hasSizeSelector();
    const optionScope = this.closest(".product-card-wrapper") || this;
    const colorInput = optionScope.querySelector('input[data-type="Color"]:checked')?.value;
    const sizeInput = optionScope.querySelector('input[data-type="Size"]:checked')?.value;
    let btnText;
    let btnDisabled = true;

    if (
      (hasColorSelector && hasSizeSelector && (!colorInput || !sizeInput)) ||
      (hasColorSelector && !hasSizeSelector && !colorInput) ||
      (hasSizeSelector && !sizeInput)
    ) {
      btnText = this.texts.noSelectedOptionBtnText;
    } else {
      const selectedVariant = this._getSelectedVariant(
        colorInput,
        sizeInput,
        hasColorSelector,
        hasSizeSelector
      );

      if (!selectedVariant) {
        btnText = this.texts.noSelectedOptionBtnText;
      } else if (!selectedVariant.available) {
        btnText = this.texts.soldOutBtnText;
      } else {
        btnText = this.texts.addToCartBtnText;
        btnDisabled = false;
      }
    }

    btn.disabled = btnDisabled;
    btn.querySelector("span").innerText = btnText;
  }

  syncCollectionCardSizeLinks() {
    const productUrl = this.getAttribute("product-url");
    const sizeLinks = [
      ...(this.closest(".card__information")?.querySelectorAll(
        ".collection-card__size[data-size-value]"
      ) || []),
    ];

    if (!productUrl || !sizeLinks.length || !this._hasSizeSelector()) {
      return;
    }

    const optionScope = this.closest(".product-card-wrapper") || this;
    const selectedColor =
      optionScope.querySelector('input[data-type="Color"]:checked')?.value;

    sizeLinks.forEach((link) => {
      const sizeValue = link.dataset.sizeValue;
      let linkedVariant = null;

      if (this._hasColorSelector() && selectedColor) {
        linkedVariant = this.variantData.find(
          (variant) =>
            variant.options[this.optionIdexes.color] === selectedColor &&
            variant.options[this.optionIdexes.size] === sizeValue
        );
      }

      if (!linkedVariant) {
        linkedVariant = this.variantData.find(
          (variant) => variant.options[this.optionIdexes.size] === sizeValue
        );
      }

      if (!linkedVariant) {
        return;
      }

      link.href = `${productUrl}?variant=${linkedVariant.id}`;
      link.dataset.variantId = linkedVariant.id;
      link.classList.toggle("is-unavailable", !linkedVariant.available);
      link.setAttribute("aria-disabled", linkedVariant.available ? "false" : "true");
    });
  }

  _getSelectedVariant(
    colorInputValue,
    sizeInputValue,
    hasColorSelector,
    hasSizeSelector
  ) {
    let findFunc;

    if (hasColorSelector && hasSizeSelector) {
      findFunc = (variant) => {
        return (
          variant.options[this.optionIdexes.color] === colorInputValue &&
          variant.options[this.optionIdexes.size] === sizeInputValue
        );
      };
    } else if (hasColorSelector) {
      findFunc = (variant) =>
        variant.options[this.optionIdexes.color] === colorInputValue;
    } else if (hasSizeSelector) {
      findFunc = (variant) =>
        variant.options[this.optionIdexes.size] === sizeInputValue;
    } else {
      findFunc = () => true;
    }

    return (
      this.variantData.find((variant) => findFunc(variant) && variant.available) ||
      this.variantData.find((variant) => findFunc(variant))
    );
  }

  _hasColorSelector() {
    const optionScope = this.closest(".product-card-wrapper") || this;
    return !!optionScope.querySelector("input.ColorSwatch__Radio");
  }

  _hasSizeSelector() {
    const optionScope = this.closest(".product-card-wrapper") || this;
    return !!optionScope.querySelector("input.SizeSwatch__Radio");
  }
}

customElements.define("custom-variant-el", CustomVariantEl);

function setCollectionPriceCurrencyClass(currencyCode) {
  const selectedCurrency = String(currencyCode || "").trim().toUpperCase();
  document.documentElement.classList.toggle(
    "is-currency-idr",
    selectedCurrency === "IDR"
  );
}

function syncCollectionPriceCurrencyClass() {
  const currencySelect = document.querySelector(
    'select[name="doubly-currencies"]'
  );
  const currentCurrency =
    currencySelect?.value || window.DoublyGlobalCurrency?.currentCurrency;

  if (currentCurrency) {
    setCollectionPriceCurrencyClass(currentCurrency);
  }
}

document.addEventListener("change", (event) => {
  if (!event.target.matches('select[name="doubly-currencies"]')) {
    return;
  }

  setCollectionPriceCurrencyClass(event.target.value);
});

document.addEventListener("click", (event) => {
  const currencyOption = event.target.closest(
    ".doubly-nice-select .option[data-value]"
  );
  if (!currencyOption) {
    return;
  }

  setCollectionPriceCurrencyClass(currencyOption.dataset.value);
});

document.addEventListener("DOMContentLoaded", () => {
  syncCollectionPriceCurrencyClass();
  [250, 750, 1500, 3000].forEach((delay) => {
    window.setTimeout(syncCollectionPriceCurrencyClass, delay);
  });
});

function collectionHasActiveFilters() {
  return [...new URLSearchParams(window.location.search).keys()].some((key) =>
    key.startsWith("filter.")
  );
}

function getCollectionProductTitle(item) {
  return (
    item.dataset.productTitle ||
    item.querySelector(".card__heading a")?.textContent ||
    ""
  )
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

function normalizeCollectionColor(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function getSelectedCollectionColors() {
  const selectedColors = new Set();
  const checkedFilters = document.querySelectorAll(
    '#FacetFiltersForm input[type="checkbox"]:checked, #FacetFiltersFormMobile input[type="checkbox"]:checked'
  );

  checkedFilters.forEach((input) => {
    const filterGroup = input.closest(".js-filter, .mobile-facets__details");
    const filterLabel =
      filterGroup?.querySelector(
        ".facets__summary, .mobile-facets__summary, .facets__heading"
      )?.textContent || "";

    if (!/colou?r/i.test(input.name) && !/colou?r/i.test(filterLabel)) {
      return;
    }

    const color = normalizeCollectionColor(input.value);
    if (color) {
      selectedColors.add(color);
    }
  });

  return selectedColors;
}

function deduplicateFilteredCollectionProducts() {
  const grid = document.getElementById("product-grid");
  if (!grid || !collectionHasActiveFilters()) {
    return;
  }

  const selectedColors = getSelectedCollectionColors();
  const productsByTitle = new Map();
  const productItems = [
    ...grid.querySelectorAll("[data-collection-product-item]"),
  ];

  productItems.forEach((item) => {
    const title = getCollectionProductTitle(item);
    if (!title) {
      return;
    }

    if (!productsByTitle.has(title)) {
      productsByTitle.set(title, []);
    }
    productsByTitle.get(title).push(item);
  });

  productsByTitle.forEach((matchingProducts) => {
    const selectedColorProduct = matchingProducts.find((item) =>
      selectedColors.has(
        normalizeCollectionColor(item.dataset.productPrimaryColor)
      )
    );
    const productToKeep = selectedColorProduct || matchingProducts[0];

    matchingProducts.forEach((item) => {
      if (item !== productToKeep) {
        item.remove();
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  deduplicateFilteredCollectionProducts();

  const productGridContainer = document.getElementById("ProductGridContainer");
  if (!productGridContainer) {
    return;
  }

  const observer = new MutationObserver(() => {
    window.requestAnimationFrame(deduplicateFilteredCollectionProducts);
  });
  observer.observe(productGridContainer, { childList: true, subtree: true });
});

document.addEventListener("click", async (event) => {
  const button = event.target.closest("[data-collection-load-more-button]");
  if (!button || button.disabled) {
    return;
  }

  const nextUrl = button.dataset.nextUrl;
  const wrapper = button.closest("[data-collection-load-more]");
  const currentGrid = document.getElementById("product-grid");
  const label = button.querySelector("[data-load-more-label]");
  const spinner = button.querySelector("[data-load-more-spinner]");

  if (!nextUrl || !wrapper || !currentGrid) {
    return;
  }

  button.disabled = true;
  button.setAttribute("aria-busy", "true");
  label.textContent = "Loading...";
  spinner?.classList.remove("hidden");

  try {
    const response = await fetch(nextUrl, {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (!response.ok) {
      throw new Error(`Unable to load collection page: ${response.status}`);
    }

    const html = await response.text();
    const nextDocument = new DOMParser().parseFromString(html, "text/html");
    const nextGrid = nextDocument.getElementById("product-grid");
    const nextButton = nextDocument.querySelector(
      "[data-collection-load-more-button]"
    );

    if (!nextGrid) {
      throw new Error("The next collection page did not contain a product grid.");
    }

    const newItems = [...nextGrid.children];
    currentGrid.append(...newItems);
    deduplicateFilteredCollectionProducts();

    if (nextButton?.dataset.nextUrl) {
      button.dataset.nextUrl = nextButton.dataset.nextUrl;
      button.disabled = false;
      button.removeAttribute("aria-busy");
      label.textContent = "Show More";
      spinner?.classList.add("hidden");
    } else {
      wrapper.remove();
    }
  } catch (error) {
    console.error(error);
    button.disabled = false;
    button.removeAttribute("aria-busy");
    label.textContent = "Try Again";
    spinner?.classList.add("hidden");
  }
});
